import { IMAGES, WA_MESSAGES } from "@/config/business";
import { WhatsAppButton } from "./CtaButtons";

const About = () => (
  <section id="about" className="scroll-mt-24 py-16 sm:py-24">
    <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-8 lg:grid-cols-2 lg:gap-16">
      <div className="relative">
        <div
          className="absolute -left-3 -top-3 h-full w-full rounded-2xl border border-[#C5A059]/40"
          aria-hidden="true"
        />
        <img
          src={IMAGES.about.src}
          alt={IMAGES.about.alt}
          loading="lazy"
          decoding="async"
          className="relative aspect-[4/3] w-full rounded-2xl object-cover shadow-[0_16px_32px_-4px_rgba(44,39,32,0.10)]"
        />
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#9E7B36]">
          About GK Wellness
        </p>
        <h2 className="mt-3 font-serif text-3xl font-medium tracking-tight text-[#1C1917] sm:text-4xl">
          A Space to Relax, Recharge &amp; Reconnect
        </h2>
        <p className="mt-5 text-sm leading-relaxed text-[#57534E] sm:text-base">
          GK Wellness &amp; Luxury Spa offers a relaxing wellness experience in Singasandra,
          Bengaluru. Choose from a range of massage and wellness experiences designed to help you
          slow down, unwind and enjoy some well-deserved personal time.
        </p>
        <p className="mt-4 text-sm leading-relaxed text-[#57534E] sm:text-base">
          Located near Manipal County Road, GK Wellness makes it convenient to book your wellness
          experience through WhatsApp.
        </p>
        <div className="mt-8">
          <WhatsAppButton
            message={WA_MESSAGES.general}
            label="Book Your Experience"
            testId="about-whatsapp-cta"
          />
        </div>
      </div>
    </div>
  </section>
);

export default About;
